/**
 * FERP Portal - My Documents Page (DRR-074 Tabulator + DRR-079 PDF Pipeline)
 *
 * EXECUTE Phase: Workflow documents, attachments, and PDF management.
 * Uses DocumentManager which combines Tabulator table pattern with
 * DRR-079 PDF viewer, annotation, signing, and export capabilities.
 *
 * Documents are NOT just CRUD records — they are attached files.
 */

import { DocumentManager } from '@/components/documents';

export function MyDocumentsPage() {
  return <DocumentManager />;
}

export default MyDocumentsPage;
